import React from "react";

const ProductImage = ({ image }) => {
  return <img className="product__image" src={image} alt="product" />;
};

export default ProductImage;
